<script setup lang="ts">

const props = defineProps<{
    status: number;
    authenticated: boolean;
    home_url: string | null;
    is_monitoramento: boolean;
    image: string | null;
}>()

const statusMessages = {
    400:{
        title: '400 Bad Request',
        subtitle: 'A requisição está errada ou malformada',
        description: 'Não conseguimos completar a ação solicitada, por favor fale com nossa equipe de suporte.',
    },
    401: {
        title: '401 Unauthorized',
        subtitle: 'Não autorizado',
        description: 'Fizemos tudo corretamente, mas por algum motivo o servidor que recebe as informações não conseguiu autenticar. Por favor, entre em contato com nossa equipe de suporte.',
    },
    403: {
        title: '403 Forbidden',
        subtitle: 'Acesso proibido',
        description: 'Muito estranho, mas por algum motivo o sistema não teve permissão para fazer o que você queria, por favor fale com nossa equipe de suporte.',
    },
    404: {
        title: '404 Not Found',
        subtitle: 'Página não encontrada',
        description: 'Infelizmente não encontramos a página que você procura, entre em contato com nosso time de suporte, talvez o GPS deles te ajude.',
    },
    409: {
        title: '409 Conflict',
        subtitle: 'Conflito de dados',
        description: 'Existe um problema ao tentar fazer a ação desejada, será que o que você esta tentando criar, já não existe? Em todo caso, por favor fale com nossa equipe de suporte.',
    },
    500: {
        title: '500 Internal Server Error',
        subtitle: 'Algo deu errado no servidor',
        description: 'Vixi, esse erro não é comum, por favor chame nosso time de suporte e informe o número desse erro.',
    },
    502: {
        title: '502 Bad Gateway',
        subtitle: 'Um servidor intermediário recebeu uma resposta inválida',
        description: 'Estamos tentando descobrir o que houve, por favor fale com nossa equipe de suporte.',
    },
    503: {
        title: '503 Service Unavailable',
        subtitle: 'O serviço está temporariamente fora do ar',
        description: 'Um dos servidores da Prodesp, Detran ou Serpro aparentemente caiu, vamos torcer que ele se recupere logo.',
    },
    504: {
        title: '504 Gateway Timeout',
        subtitle: 'O servidor demorou demais para responder',
        description: 'Seja lá o que foi que você pediu, o servidor demorou tempo demais para responder e acabou com o tempo máximo que as diretrizes de segurança permitem, tente novamente em alguns minutos.',
    },
    default: {
        title: 'Erro',
        subtitle: 'Ocorreu um erro!',
        description: 'Vixi, esse erro não é comum, por favor chame nosso time de suporte e informe o ocorrido.',
    },
}

const error = computed(() => {
    if (props.status && statusMessages[props.status as keyof typeof statusMessages]) {
        return statusMessages[props.status as keyof typeof statusMessages]
    }
    return statusMessages.default
})
</script>

<script lang="ts">
import { computed } from 'vue';
import menu_layout from '../../Layouts/menu_layout.vue'
import simple_layout from '../../Layouts/simple_layout.vue'

export default {
	layout: (h, page) => {
		const authenticated = page.props.authenticated
        const is_monitoramento = page.props.is_monitoramento

        return h(!authenticated || is_monitoramento ? simple_layout : menu_layout, () => page)
	}
}
</script>

<template>
	<div class="card text-center p-5">
		<h1 class="display-4">{{ error.title }}</h1>

		<h4>{{ error.subtitle }}</h4>

		<p class="mb-4 mt-4 fw-bold fs-5" style="color: #686f7a;">
			{{ error.description }}
		</p>

        <div class="flex justify-center" v-if="props.image">
            <img :src="props.image" alt="imagem do erro" class="img-fluid" />
        </div>

		<div v-if="props.home_url">
			<a class="btn btn-primary mt-5" :href="props.home_url">
				Voltar para a página inicial
			</a>
		</div>
	</div>
</template>
